// frontend/src/config/planConfig.js
// ═══════════════════════════════════════════════════════════════
// FUENTE ÚNICA DE VERDAD — Planes, Precios y Features de UrbanQ
// Todos los componentes DEBEN importar de aquí
// ═══════════════════════════════════════════════════════════════

export const PLANS = [
  {
    id: 'monthly',
    name: 'Mensual',
    duration: '30 días',
    durationMonths: 1,
    price: 40,
    originalPrice: null,
    pricePerMonth: 40,
    savings: null,
    badge: null,
    hasTrial: true,
    trialDays: 7,
    recommended: false,
    features: [
      'Gestión completa de residentes',
      'Hasta 50 unidades',
      'Panel de administración completo',
      'Reportes financieros básicos',
      'Notificaciones automáticas',
      'Soporte por email (48h)',
      '1 torre/bloque'
    ],
    color: '#667eea',
    icon: 'star'
  },
  {
    id: 'biannual',
    name: 'Semestral',
    duration: '6 meses',
    durationMonths: 6,
    price: 240,
    originalPrice: null,
    pricePerMonth: 40,
    savings: null,
    badge: 'Más popular',
    hasTrial: true,
    trialDays: 14,
    recommended: true,
    features: [
      'Todo lo del plan mensual',
      'Hasta 200 unidades',
      'Gestión de múltiples torres',
      'Reportes avanzados + Exportar Excel',
      'Soporte prioritario (24h)',
      'Backup automático semanal',
      'Módulo de mantenimiento',
      'API de integración básica'
    ],
    color: '#764ba2',
    icon: 'crown'
  },
  {
    id: 'annual',
    name: 'Anual',
    duration: '12 meses',
    durationMonths: 12,
    price: 432,
    originalPrice: 480,
    pricePerMonth: 36,
    savings: '10% de descuento',
    badge: 'Mejor valor',
    hasTrial: true,
    trialDays: 30,
    recommended: false,
    features: [
      'Todo lo del plan semestral',
      'Unidades ilimitadas',
      'Torres ilimitadas',
      'Soporte 24/7 por WhatsApp',
      'Backup automático diario',
      'Módulo de reservas',
      'Integración con contabilidad',
      'UrbanIA — Asistente IA',
      'API completa para integraciones',
      'Capacitación personalizada',
      'Gerente de cuenta dedicado'
    ],
    color: '#48bb78',
    icon: 'rocket'
  }
];

export const getPlanById = (id) => PLANS.find(p => p.id === id) || PLANS[0];
export const getPlansArray = () => PLANS;
export const getPlanPrice = (id) => {
  const plan = getPlanById(id);
  return plan ? plan.price : 40;
};

export const PLAN_NAMES = {
  'monthly': 'Plan Mensual',
  'biannual': 'Plan Semestral',
  'annual': 'Plan Anual'
};

export default { PLANS, getPlanById, getPlansArray, getPlanPrice, PLAN_NAMES };
